module.exports = __webpack_public_path__ + "static/media/2_Breaking-down-the-barriers-to-connected-medication-management_PRINT-compressed.3ccd763c.pdf";